import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  assignedProgramRequest,
  markAsCompleteRequest,
} from "../../../../store/slices/selfSlice";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import ContentPreviewIFrame from "../ContentPreviewIFrame";
import useMobileView from "../../../common/hooks/useMobileView";
import { GetMilestonePreviewUrl } from "../../../../helpers/GlobalHelper";
import { RouteConstants } from "../../../../constants";
import "./learning-program-journey-milestone-details.scss";

const LearningProgramMilestoneObjDetails = ({
  enterprise,
  token,
  labels,
  menuCustomised,
  program,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const intl = useIntl();

  const prevURL =
    window.location.pathname.split("milestones/")[0] + "milestones";

  const { isMobile } = useMobileView();

  const [previewUrl, setPreviewUrl] = useState(null);
  const [completeManually, setCompleteManually] = useState(false);

  useEffect(() => {
    if (!isMobile) {
      navigate(
        `${RouteConstants.APP_ROUTE_LEARNING_JOURNEY_PROGRAMS_MILESTONES.replace(
          ":id",
          params.id
        )}`
      );
    }
  }, [isMobile]);

  const milestone = program?.milestones.find((item) => item.id == params?.mid);

  const customLabels = [
    labels[1],
    {
      label: program?.learningPathway?.name,
      to: prevURL,
    },
    {
      label: milestone?.milestone.name,
    },
  ];

  const object = milestone?.objects.find((item) => item.id == params.oid);

  return (
    <div>
      <ContentPreviewIFrame
        completeManually={completeManually}
        object={object}
        previewUrl={previewUrl}
        setCompleteManually={setCompleteManually}
        setPreviewUrl={setPreviewUrl}
      />
      <CustomBreadCrumbs
        labels={customLabels}
        menuCustomised={menuCustomised}
        navigate={navigate}
        editLabel={program?.learningPathway?.name}
      />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header flex-column align-items-start">
          <div className="edexlms-program-milestobe-object-conatiner">
            <div className="edexlms-program-milestone-object-preview">
              <div
                data-testid="object-banner"
                className="edexlms-program-milestone-object-preview-baner relative"
                style={{
                  backgroundColor: "none",
                  height: "230px",
                  padding: 0,
                  cursor: object?.learningObject?.contentType
                    ? "pointer"
                    : "default",
                }}
                onClick={() => {
                  const payload = {
                    userLearningObjectId: object?.id,
                    domain: enterprise.subDomain,
                    accessToken: token,
                    launchUrl: object?.learningObject.launchPathUrl,
                  };

                  const previewURL = GetMilestonePreviewUrl(
                    object?.learningObject,
                    payload
                  );

                  if (previewURL) {
                    setPreviewUrl(previewURL);
                  }
                }}
              >
                <>
                  <img
                    style={{
                      opacity: 0.5,
                      objectFit: "cover",
                      borderRadius: "8px 8px 0px 0px",
                    }}
                    src={`${new URL(
                      object?.learningObject?.bannerImage,
                      process.env.REACT_APP_URL
                    ).toString()}`}
                    alt={
                      object?.learningObject.milestone?.learningObject?.name ||
                      ""
                    }
                  />
                  {(object.learningObject.contentType && (
                    <i
                      className="pi pi-play-circle"
                      style={{
                        color: "var(--edexlms-primary-color)",
                        fontSize: 50,
                        position: "absolute",
                      }}
                    />
                  )) ||
                    null}
                </>
              </div>
            </div>
            <div
              className="w-full p-3 bg-primary"
              style={{ borderRadius: "0px 0px 8px 8px" }}
            >
              <span className="text-2xl font-bold">
                {object?.learningObject.name || ""}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  program: state.self.program,
  enterprise: state.global.enterprise,
  token: state.auth.session.accessToken,
});

const mapDisptachToProps = (dispatch) => ({
  assignedProgramRequest: (data) => dispatch(assignedProgramRequest(data)),
  markAsCompleteRequest: (data) => dispatch(markAsCompleteRequest(data)),
});

export default connect(
  mapStateToProps,
  mapDisptachToProps
)(LearningProgramMilestoneObjDetails);
